/**
 * Rank app — /apps/rank/* — RETIRED 2026-10-05 (DEPRECATION_REGISTER DEP-029).
 *
 * Rank was the Session app under a second name: `NewRankScreen` was a copy of
 * Session's setup, the host and join screens WERE Session's, and each app's
 * list showed the other's sessions. One job, one app: every Rank link now opens
 * the same place in Session, so a bookmark or an invite that was already sent
 * still works.
 *
 * `RankHomeScreen` and `NewRankScreen` are kept in this folder as the record of
 * what it was; nothing mounts them.
 */

import { Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom';

function ToSession({ host = false }: { host?: boolean }) {
  const { sessionId } = useParams<{ sessionId: string }>();
  const { search } = useLocation();
  return <Navigate to={`/apps/session/${sessionId}${host ? '/host' : ''}${search}`} replace />;
}

export default function RankApp() {
  return (
    <Routes>
      <Route index element={<Navigate to="/apps/session" replace />} />
      <Route path="new" element={<Navigate to="/apps/session/new" replace />} />
      <Route path=":sessionId/host" element={<ToSession host />} />
      <Route path=":sessionId" element={<ToSession />} />
      <Route path="*" element={<Navigate to="/apps/session" replace />} />
    </Routes>
  );
}
